'use client';

import { useClientUserInfo } from '../../common/userinfo/InitialUserInfoFetcherAndParser/utils/useClientUserInfo';
import { useChangeLanguage } from '../hooks/useChangeLanguage';
import { LanguageChangeMenu } from '../LanguageChangeMenu/LanguageChangeMenu.use-client';

export type LanguageTranslations = {
  errorTitle: string;
  errorSubtitle: string;
  germanSubtitle: string;
  englishSubtitle: string;
  arabicSubtitle: string;
  frenchSubtitle: string;
};

export interface LanguageProps {
  translations: LanguageTranslations;
}

const LanguageScreen = ({ translations }: LanguageProps) => {
  const { onChangeLanguage, isUserUpdateLoading } = useChangeLanguage({
    translations: {
      errorSubtitle: translations.errorSubtitle,
      errorTitle: translations.errorTitle,
    },
  });

  const { language } = useClientUserInfo();

  return (
    <LanguageChangeMenu
      translations={translations}
      onLanguageValueChange={onChangeLanguage}
      currentValue={language}
      isDisabled={isUserUpdateLoading}
      isLoading={isUserUpdateLoading}
    />
  );
};

export { LanguageScreen };
